import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { StepDialogData } from "./edit-step.component";

@Component({
  selector: 'dialog-step',
  templateUrl: 'dialog-step.html',
  styleUrls: ['dialog-step.css']
})
export class StepDialog {

  constructor(
    public dialogRef: MatDialogRef<StepDialog>,
    @Inject(MAT_DIALOG_DATA) public data: StepDialogData) { }

  onClickCancel(): void {
    this.dialogRef.close();
  }

  addSubStep(): void {
    this.data.selectItems.push({
      name: 'item' + this.data.selectItems.length.toString(),
      duration: 1,
      unit: 'months',
      cost: '1',
      professional: '1',
      groupName: '',
      overlapStep: false,
    });
    //this.onCostBlur();
    //this.onProfessionalBlur();
  }

  addUserInput(): void {
    this.data.userInputs.push({
      name: 'item' + this.data.userInputs.length.toString(),
      qty: 1
    });
  }

  onCostBlur(idx: number) {
    let totalCost = 0;
    let rangeValue: string | null = null;

    //for (let j = 0; j < this.data.selectItems.length; j++) {
      const item = this.data.selectItems[idx];
      if (typeof item.cost === 'string' && item.cost.includes('-')) {
        rangeValue = item.cost;
      } else {
        totalCost = parseFloat(item.cost);
      }
    //}

    this.data.cost = rangeValue !== null ? rangeValue : totalCost.toString();
    this.data.selectItems[idx].cost = this.data.cost;
  }

  onProfessionalBlur(idx: number) {
    let totalProfessional = 0;
    let rangeValue: string | null = null;

    //for (let j = 0; j < this.data.selectItems.length; j++) {
      const item = this.data.selectItems[idx];
      if (typeof item.professional === 'string' && item.professional.includes('-')) {
        rangeValue = item.professional;
      } else {
        totalProfessional += parseFloat(item.professional);
      }
    //}

    this.data.professional = rangeValue !== null ? rangeValue : totalProfessional.toString();
    this.data.selectItems[idx].professional = this.data.professional;
  }





  deleteSubStep(idx: number): void {
    this.data.selectItems.splice(idx, 1);
  }
  deleteUserInput(idx: number): void {
    this.data.userInputs.splice(idx, 1);
  }

  // Helper function to format the cost or professional values
  formatRange(value: any): string {
    if (value && typeof value === 'object' && value.min !== undefined && value.max !== undefined) {
      // Return range as "min - max"
      return `${value.min} - ${value.max}`;
    } else if (typeof value === 'number' || typeof value === 'string') {
      // Return single value
      return value.toString();
    } else {
      return '';
    }
  }

  get formattedCost(): string {
    return this.formatRange(this.data.cost);
  }

  set formattedCost(value: string) {
    this.data.cost = this.parseRange(value);
  }

  get formattedProfessional(): string {
    return this.formatRange(this.data.professional);
  }

  set formattedProfessional(value: string) {
    this.data.professional = this.parseRange(value);
  }

  onCostChange(value: string): void {
    this.data.cost = this.parseRange(value);
  }

  onProfessionalChange(value: string): void {
    this.data.professional = this.parseRange(value);
  }

  parseRange(value: string): any {
    if (value.includes('-')) {
      const [min, max] = value.split('-').map(v => parseFloat(v.trim()));
      if (!isNaN(min) && !isNaN(max)) {
        return { min, max };
      }
    }
    const singleValue = parseFloat(value);
    return !isNaN(singleValue) ? singleValue : '';
  }


}
